import { render, staticRenderFns } from "./PersonListItem.vue?vue&type=template&id=18e54424"
import script from "./PersonListItem.vue?vue&type=script&lang=js"
export * from "./PersonListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports